import React from "react";
import { Button, Container, Row, Col, Form, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';

export default class DashBoard extends React.Component {

    state = {
        dashData: {},
        monitoredOnly: false
    };

    componentDidMount() {
        context.on("updateConnections", () => {
            this.setState({});            
        });
        this.updateData();
    }

    async updateData() {
        let dashData = await context.makeRequest("Admin.getDashData", {});
        //console.log(dashData);
        this.setState({
            dashData: dashData.result
        });
    }

    getDisplayValue(name) {
        if (this.state.dashData) {
            let paramName = name + (this.state.monitoredOnly ? "Monitored" : "");
            if (typeof this.state.dashData[paramName] !== "undefined") {
                return this.state.dashData[paramName];
            }
        }
        return "-";
    }

    render() {
        return (
            <div style={{ flex: 1 }}>
                <Button 
                    style={{ marginRight: 10, marginTop: 0 }}
                    onChange={(val) => { 
                        this.updateData();
                    }}
                >Refresh</Button>
                <ToggleButton 
                    style={{ marginRight: 10, marginBottom: 0 }}
                    type="checkbox" value={true} checked={ this.state.monitoredOnly } variant={ this.state.monitoredOnly ? "primary" : "secondary" }
                    onClick={(val) => { 
                        this.setState({ monitoredOnly: typeof this.state.monitoredOnly != "undefined" ? !this.state.monitoredOnly : true });
                        this.updateData();
                    }}
                >Monitored Only</ToggleButton>
                <div style={ { clear: 'left' } }></div>

                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/sites", "Sites");
                    }}>
                    <div className={ "value" }>
                        { this.state.dashData?.siteCount }
                    </div>
                    <div className={ "title" }>
                        Sites
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/sites?seenSince=" + new Date(Date.now() - 60*60*1000).toISOString(), "Sites");
                    }}>
                    <div className={ "value" } style={{  }}>
                        { this.getDisplayValue("siteCountSeenLastHour") }
                    </div>
                    <div className={ "title" }>
                        Sites Seen Last hour
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/sites?seenSince=" + new Date(Date.now() - 24*60*60*1000).toISOString(), "Sites");
                    }}>
                    <div className={ "value" } style={{ }}>
                        { this.getDisplayValue("siteCountSeenLastDay") }
                    </div>
                    <div className={ "title" }>
                        Sites Seen Last 24 hours
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/sites?withAlert=1", "Sites With Alert");
                    }}
                >
                    <div className={ "value" } style={{ color: this.state.dashData?.siteCountWithAlert > 0 ? 'orange' : 'green' }}>
                        { this.getDisplayValue("siteCountWithAlert") }
                    </div>
                    <div className={ "title" }>
                        Sites With Alert
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/sites?withAlert=1&alertLevel=FATAL", "Sites With Alert");
                    }}
                >
                    <div className={ "value" } style={{ color: this.state.dashData?.siteCountWithFatalAlert > 0 ? 'red' : 'green' }}>
                        { this.getDisplayValue("siteCountWithFatalAlert") }
                    </div>
                    <div className={ "title" }>
                        Sites With Critical Alert
                    </div>
                </div>
                <div style={ { clear: 'left' } }></div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/alerts", "Alerts");
                    }}
                >
                    <div className={ "value" }>
                        { this.state.monitoredOnly ? this.state.dashData?.alertCountMonitored : this.state.dashData?.alertCount || "-" }
                    </div>
                    <div className={ "title" }>
                        Alerts
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/alerts?level=FATAL", "Alerts");
                    }}
                >
                    <div className={ "value" } style={{ color: this.state.dashData?.alertCountFatal > 0 ? 'red' : 'green' }}>
                        { this.getDisplayValue("alertCountFatal") }
                    </div>
                    <div className={ "title" }>
                        Critical Alerts
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/alerts?since=" + new Date(Date.now() - 60*60*1000).toISOString(), "Alerts");
                    }}
                >
                    <div className={ "value" } style={{ color: this.state.dashData?.alertCountCreatedLastHour > 0 ? 'orange' : 'green' }}>
                        { this.getDisplayValue("alertCountCreatedLastHour") }
                    </div>
                    <div className={ "title" }>
                        New Alerts Last Hour
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/alerts?since=" + new Date(Date.now() - 24*60*60*1000).toISOString(), "Alerts");
                    }}
                >
                    <div className={ "value" } style={{ color: this.state.dashData?.alertCountCreatedLastDay > 0 ? 'orange' : 'green' }}>
                        { this.getDisplayValue("alertCountCreatedLastDay") }
                    </div>
                    <div className={ "title" }>
                        New Alerts Last 24 Hours
                    </div>
                </div>
                <div style={ { clear: 'left' } }></div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/devices", "Sites");
                    }}>
                    <div className={ "value" }>
                        { this.state.dashData?.deviceCount }
                    </div>
                    <div className={ "title" }>
                        Devices
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/devices?seenSince=" + new Date(Date.now() - 60*60*1000).toISOString(), "Sites");
                    }}
                >
                    <div className={ "value" }>
                        { this.state.dashData?.deviceCountSeenLastHour }
                    </div>
                    <div className={ "title" }>
                        Devices Recently Seen
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/devices?seenSince=" + new Date(Date.now() - 24*60*60*1000).toISOString(), "Sites");
                    }}
                >
                    <div className={ "value" }>
                        { this.state.dashData?.deviceCountSeenLastDay }
                    </div>
                    <div className={ "title" }>
                        Devices Seen Last Day
                    </div>
                </div>
                <div style={ { clear: 'left' } }></div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/users", "Sites");
                    }}>
                    <div className={ "value" }>
                        { this.state.dashData?.userCount }
                    </div>
                    <div className={ "title" }>
                        Users
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/users?seenSince=" + new Date(Date.now() - 60*60*1000).toISOString(), "Sites");
                    }}
                >
                    <div className={ "value" }>
                        { this.state.dashData?.userCountSeenLastHour }
                    </div>
                    <div className={ "title" }>
                        Users Recently Seen
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/users?seenSince=" + new Date(Date.now() - 24*60*60*1000).toISOString(), "Sites");
                    }}
                >
                    <div className={ "value" }>
                        { this.state.dashData?.userCountSeenLastDay }
                    </div>
                    <div className={ "title" }>
                        Users Seen Last Day
                    </div>
                </div>
                <div style={ { clear: 'left' } }></div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/gateway", "Sites");
                    }}>
                    <div className={ "value" }>
                        { context.gatewayConnections.length }
                    </div>
                    <div className={ "title" } >
                        Gateway connections
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/gateway", "Sites");
                    }}>
                    <div className={ "value" }>
                        { context.gatewayConnections.filter(cn => cn.type === "user").length }
                    </div>
                    <div className={ "title" } >
                        User connections
                    </div>
                </div>
                <div className={ "card dashCard" } style={{ cursor: "pointer" }}
                    onClick={ () => {
                        context.navigate("#/gateway", "Sites");
                    }}>
                    <div className={ "value" }>
                        { context.gatewayConnections.filter(cn => cn.type === "device").length }
                    </div>
                    <div className={ "title" } >
                        Device connections
                    </div>
                </div>
            </div>
        );
    }
}